var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 9.00001C19.75 8.55151 19.386 8.18751 18.9375 8.18751L2.72854 8.18751L8.93522 2.27576C9.25982 1.9666 9.27322 1.4527 8.96325 1.12688C8.65369 0.801884 8.13978 0.78929 7.81478 1.09885L0.726129 7.85073C0.419004 8.15785 0.250003 8.56573 0.250003 9.00001C0.250003 9.43388 0.419004 9.84217 0.740348 10.1627L7.81478 16.9008C8.13978 17.2103 8.65369 17.1973 8.96325 16.8727C9.27322 16.5481 9.26022 16.0338 8.93522 15.7243L2.70253 9.81251L18.9375 9.81251C19.386 9.81251 19.75 9.44851 19.75 9.00001Z",
    fill: "#272D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.517e81eb2fd47ac4bec9c865b3379ef1.svg";
export { ForwardRef as ReactComponent };